// extracted by mini-css-extract-plugin
module.exports = {"CurriculumPage":"CurriculumPage_CurriculumPage__3eXU5"};